module.exports = __webpack_public_path__ + "img/supplier.d6102c28.png";